import { Box, Typography } from "@mui/material";
import viewSignRequestStyles from "./ViewSignRequest.styles";

const styles = viewSignRequestStyles;

interface MessageCardProps {
  message?: string;
}

/** Left-column card showing the email message sent to signers. */
const MessageCard: React.FC<MessageCardProps> = ({ message }) => {
  if (!message?.trim()) return null;

  return (
    <Box sx={styles.messageCard}>
      <Typography component="h2" sx={styles.messageTitle}>
        Message to signers
      </Typography>
      <Typography component="div" sx={styles.messageBody}>
        {message}
      </Typography>
    </Box>
  );
};

export default MessageCard;
